import { useState } from "react";
import Header from "../Header";
import Banner from "../Banner";
import GlobalMenu from "../GlobalMenu";
import Youtube from "./parts/Youtube";
import Podcast from "./parts/Podcast";
import Tiktok from "./parts/Tiktok";
import Footer from "../Footer";
import { Ads, StickyAds } from "../../components/ads/Ads";
import { GlobalShare } from "../SocialButtons";
import styles from "../../styles/homepage/Home.module.scss";

const MultimediaPage = ({ url }) => {
  const [isMounted, setIsMounted] = useState(true);

  return (
    <div className={styles.container}>
      <Header />
      <Banner />
      <GlobalMenu />
      <div className="body_wrapper">
        <div className={styles.adsContainer}>
          <Ads
            id={`multimedia-billboard-desktop`}
            adType="billboard"
            deviceType="desktop"
            pageType="elec_multimedia_page"
          />
          <Ads
            id={`multimedia-billboard-mobile`}
            adType="billboard"
            deviceType="mobile"
            pageType="elec_multimedia_page"
          />
        </div>
        <div className={styles.multimediaHeader}>
          <h1 className={styles.multimediaTitle}>#PHVOTE MULTIMEDIA</h1>
          <GlobalShare
            title="Share this page"
            url={url}
            fbQuote="2022 Philippine elections - Multimedia #PHVote #WeDecide"
            tWQuoute="2022 Philippine elections - Multimedia #PHVote #WeDecide"
            toolTipId={"toolTip_Default"}
            isMounted={isMounted}
            containerStyle={styles.gs_multimedia}
          />
        </div>
        <Youtube />
        <Podcast />
        <Tiktok />
        <Ads
          id={`multimedia-leaderboard1-desktop`}
          adType="leaderboard1"
          deviceType="desktop"
          pageType="elec_multimedia_page"
        />
        <Ads
          id={`multimedia-middle1-mobile`}
          adType="middle1"
          deviceType="mobile"
          pageType="elec_multimedia_page"
        />
        <StickyAds
          id={`multimedia-sticky-desktop`}
          deviceType="desktop"
          pageType="elec_multimedia_page"
        />
        <StickyAds
          id={`multimedia-sticky-mobile`}
          deviceType="mobile"
          pageType="elec_multimedia_page"
        />
      </div>
      <Footer />
    </div>
  );
};

export default MultimediaPage;
